<template>
  <fragment>
    <div class="container dashboard">
      <div class="col-12 title">
        <h1>My Account</h1>
        <div class="sub">
          {{ $user.currentUser.first_name + ' '+ $user.currentUser.last_name }}
        </div>
      </div>
      <div class="row" style="margin-top: 3rem">
        <div v-if="tabs.length > 1" class="col-12">
          <div class="dashboard-tabs">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              type="button"
              :class="selectedTab === tab.id && 'active'"
              @click="selectTab(tab.id)"
            >
              {{ tab.title }}
            </button>
          </div>
        </div>
        <notifications-tab v-if="selectedTab === 'notifications'" />
      </div>
    </div>
  </fragment>
</template>

<script>
import NotificationsTab from './components/Tabs/NotificationsTab.vue';

export default {
    name: 'CollegeAdminAccount',
    components: {
        NotificationsTab
    },
    data() {
        return {
            selectedTab: 'notifications',
            tabs: [
                { id: 'notifications', title: 'Notifications' },
            ]
        }
    },
    methods: {
        selectTab(tab) {
            this.selectedTab = tab;
        }
    }
}
</script>


<style lang="scss">
@import '@/scss/layouts/_collegeadmin.scss';
.title {
      height: auto;
    display: flex;
    flex-direction: column;
    align-items: left;
    padding: 0;
    line-height: 1.05;
    margin-bottom: 1rem;

    h1 {
      color: $white;
      font-family: $sans;
      font-size: 1.33rem;
      display: inline-block;
      margin: 0 0 0.3rem 0;
      line-height: inherit;
      letter-spacing: 0.05rem;
    }

    .sub {
      font-size: 16px;
      font-weight: 500;
      color: #bfc0c7;
    }
  }
</style>
